import React, { useState } from 'react';
import classnames from 'classnames';
import { u as useResizeObserver } from './useResizeObserver-Drw72siq.js';
import { s as styles, B as BannerIcon } from './BannerIcon-Cr1k10eQ.js';
import { T as Text } from './Text-BCmEgJBp.js';
import { B as Button } from './Button-DJQVVE0-.js';
import { B as ButtonDismiss } from './ButtonDismiss-C4D25Ln_.js';

function Banner({ children, type, primaryAction, dismissible = true, icon, onDismiss, }) {
    const [showBanner, setShowBanner] = useState(true);
    const bannerIcon = icon || getBannerIcon(type);
    const bannerWidths = {
        small: 320,
        medium: 480,
    };
    const [bannerRef, { width: bannerWidth = bannerWidths.small }] = useResizeObserver.useResizeObserver({
        widths: bannerWidths,
    });
    if (primaryAction != undefined) {
        primaryAction = Object.assign({
            size: "small",
            type: "tertiary",
            variation: type === "notice" ? "learning" : "work",
        }, primaryAction);
    }
    const bannerClassNames = classnames(styles.banner, {
        [styles.medium]: bannerWidth >= bannerWidths.medium,
    });
    if (!showBanner)
        return null;
    return (React.createElement("div", { className: bannerClassNames, ref: bannerRef, role: type === "error" ? "alert" : "status" },
        React.createElement("div", { className: styles.bannerContent },
            bannerIcon && React.createElement(BannerIcon, { icon: bannerIcon, type: type }),
            React.createElement("div", { className: styles.bannerChildren },
                React.createElement(BannerChildren, null, children)),
            primaryAction && (React.createElement("div", { className: styles.bannerAction },
                React.createElement(Button, Object.assign({}, primaryAction))))),
        dismissible && (React.createElement("div", { className: styles.closeButton },
            React.createElement(ButtonDismiss, { ariaLabel: "Dismiss notification", onClick: handleClose })))));
    function handleClose() {
        setShowBanner(!showBanner);
        onDismiss && onDismiss();
    }
}
function getBannerIcon(type) {
    switch (type) {
        case "notice":
            return "starburst";
        case "success":
            return "checkmark";
        case "warning":
            return "help";
        case "error":
            return "alert";
    }
}
function BannerChildren({ children, }) {
    if (!children)
        return React.createElement(React.Fragment, null);
    if (children && typeof children === "string") {
        return React.createElement(Text, null, children);
    }
    return React.createElement(React.Fragment, null, children);
}

export { Banner as B };
